import { ChangePasswordFormComponent } from './change-password-form/change-password-form.component';
import { AlertDialogComponent } from './dialogs/alert-dialog/alert-dialog.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { HeroToolbarComponent } from './layout/hero/hero-toolbar/hero-toolbar.component';
import { HeroComponent } from './layout/hero/hero.component';
import { LoaderComponent } from './loader/loader.component';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { NavItemLinkDirective } from './layout/nav/nav-item/nav-item-link.directive';
import { NavItemComponent } from './layout/nav/nav-item/nav-item.component';
import { NavComponent } from './layout/nav/nav.component';
import { RefreshItemComponent } from '@app/shared/components/refresh/refresh-item/refresh-item.component';
import { RefreshItemLinkDirective } from '@app/shared/components/refresh/refresh-item/refresh-item-link.directive';
import { RefreshComponent } from '@app/shared/components/refresh/refresh.component';
import { LoginHeaderFormComponent } from '@app/shared/components/login-header-form/login-header-form.component';
import { UserInfoHeaderComponent } from '@app/shared/components/user-info-header/user-info-header.component';
import { SidenavComponent } from '@app/shared/components/layout/sidenav/sidenav.component';
import { SidenavListComponent } from '@app/shared/components/layout/sidenav/sidenav-list/sidenav-list.component';
import { SidenavLinkComponent } from '@app/shared/components/layout/sidenav/sidenav-link/sidenav-link.component';
import { WidgetComponent } from '@app/shared/components/widget/widget.component';
import { ResetPasswordFormComponent } from '@app/shared/components/reset-password-form/reset-password-form.component';
import { PasswordRequirementsComponent } from '@app/shared/components/password-requirements/password-requirements.component';
import { CustomerSupportComponent } from '@app/shared/components/customer-support/customer-support.component';
import { FrametraceVisualizerDialogComponent } from '@app/shared/components/dialogs/frametrace-visualizer/frametrace-visualizer-dialog.component';
import { FrameTracerComponent } from '@app/shared/components/frame-tracer/frame-tracer.component';
import { RefreshOrdersDialogComponent } from './dialogs/refresh-orders-dialog/refresh-orders-dialog.component';
import { LiveChatDialogComponent } from '@app/shared/components/live-chat-dialog/live-chat-dialog.component';
import { NoteFormComponent } from '@app/shared/components/note-form/note-form.component';
import { ConfirmDialogComponent } from '@app/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { PrintFramePackingSlipDialogComponent } from '@app/shared/components/dialogs/print-frame-packing-slip-dialog/print-frame-packing-slip-dialog.component';
/**
 * components
 * @type {(AlertDialogComponent | ChangePasswordFormComponent | CheckboxComponent | ConfirmDialogComponent | CollapsibleComponent | FooterComponent | HeaderComponent | HeroComponent | HeroToolbarComponent | LoaderComponent | LoginDialogComponent | LoginFormComponent | LoginStaticFormComponent | NavComponent | NavItemComponent | NavItemLinkDirective | SessionTimeoutComponent | SidenavComponent | SidenavLinkComponent | SidenavListComponent | StatisticCardComponent | StatisticItemComponent | StatisticTooltipComponent | WidgetComponent | TooltipComponent | RefreshComponent | RefreshItemComponent | RefreshItemLinkDirective)[]}
 */
export const components: any[] = [
  AlertDialogComponent,
  ChangePasswordFormComponent,
  ResetPasswordFormComponent,
  FooterComponent,
  HeaderComponent,
  HeroComponent,
  HeroToolbarComponent,
  LoaderComponent,
  LoginDialogComponent,
  LoginFormComponent,
  NavComponent,
  NavItemComponent,
  NavItemLinkDirective,
  SidenavComponent,
  SidenavLinkComponent,
  SidenavListComponent,
  RefreshComponent,
  RefreshItemComponent,
  RefreshItemLinkDirective,
  LoginHeaderFormComponent,
  UserInfoHeaderComponent,
  WidgetComponent,
  PasswordRequirementsComponent,
  CustomerSupportComponent,
  FrametraceVisualizerDialogComponent,
  FrameTracerComponent,
  RefreshOrdersDialogComponent,
  LiveChatDialogComponent,
  NoteFormComponent,
  ConfirmDialogComponent,
  PrintFramePackingSlipDialogComponent,
];

export * from './change-password-form/change-password-form.component';
export * from './reset-password-form/reset-password-form.component';
export * from './dialogs/alert-dialog/alert-dialog.component';
export * from './layout/footer/footer.component';
export * from './layout/header/header.component';
export * from './layout/hero/hero-toolbar/hero-toolbar.component';
export * from './layout/hero/hero.component';
export * from './loader/loader.component';
export * from './login-dialog/login-dialog.component';
export * from './login-form/login-form.component';
export * from './layout/nav/nav-item/nav-item-link.directive';
export * from './layout/nav/nav-item/nav-item.component';
export * from './layout/nav/nav.component';
export * from './layout/sidenav/sidenav-link/sidenav-link.component';
export * from './layout/sidenav/sidenav-list/sidenav-list.component';
export * from './layout/sidenav/sidenav.component';
export * from './refresh/refresh.component';
export * from './refresh/refresh-item/refresh-item.component';
export * from './refresh/refresh-item/refresh-item-link.directive';
export * from './login-header-form/login-header-form.component';
export * from './user-info-header/user-info-header.component';
export * from './widget/widget.component';
export * from './password-requirements/password-requirements.component';
export * from './customer-support/customer-support.component';
export * from './dialogs/frametrace-visualizer/frametrace-visualizer-dialog.component';
export * from './frame-tracer/frame-tracer.component';
export * from './dialogs/refresh-orders-dialog/refresh-orders-dialog.component';
export * from '@app/shared/components/live-chat-dialog/live-chat-dialog.component';
export * from './note-form/note-form.component';
export * from './dialogs/confirm-dialog/confirm-dialog.component';
export * from './dialogs/print-frame-packing-slip-dialog/print-frame-packing-slip-dialog.component';
